import { Deserializable } from '../../protocols/deserializable';
import { UniquelyIdentifiable } from '../../protocols/uniquely-identifiable';
import { Asset } from '../../image/dto/asset';

/**
 * One brand featured at the top of an insight collection's results. Unlike the collection's products, this carries
 * its own name and logo, so it renders without a catalogue lookup.
 */
export class HighGuideInsightCollectionBrand implements Deserializable, UniquelyIdentifiable {
  /** Ascending layout order, computed server side. */
  public order: number;
  public brand: string;
  public brandNameId: string;
  public logo: Asset;
  public score: number;
  public signalCount: number;

  onDeserialize(): void {
    this.logo = window?.injector?.Deserialize?.instanceOf(Asset, this.logo);
  }

  getUniqueIdentifier(): string {
    return `${this.brandNameId}-${this.order}-${this.logo?.getUniqueIdentifier()}`;
  }
}
